"use client";

import { XMarkIcon } from "@heroicons/react/24/outline";
import { useNotificationSetupBannerContextRequired } from "@/contexts/NotificationSetupBannerContext";
import NotificationSetupSheet from "@/components/notifications/NotificationSetupSheet";

function NotificationSetupSheetMount() {
  const banner = useNotificationSetupBannerContextRequired();

  return (
    <NotificationSetupSheet
      isOpen={banner.sheetOpen}
      onClose={banner.closeSheet}
      mode={banner.mode ?? "both"}
      gaps={banner.gaps}
      locationOk={banner.locationOk}
      nearMeBusy={banner.nearMeBusy}
      pushBusy={banner.pushBusy}
      pushSupported={banner.pushSupported}
      pushVapidConfigured={banner.pushVapidConfigured}
      pushPermission={banner.pushPermission}
      pushLastError={banner.pushLastError}
      onEnableNearMe={banner.enableNearMe}
      onEnablePush={banner.enablePush}
      onFinishSetup={banner.finishSetup}
      finishBusy={banner.finishBusy}
    />
  );
}

export default function NotificationSetupBanner() {
  const banner = useNotificationSetupBannerContextRequired();

  if (!banner.visible || !banner.copy) {
    return banner.sheetOpen ? <NotificationSetupSheetMount /> : null;
  }

  return (
    <>
      <div
        className="notification-setup-banner border-b border-primary/20 bg-primary/5 px-4 py-2.5 text-sm text-foreground"
        role="region"
        aria-label="Notification setup"
      >
        <div className="mx-auto flex max-w-7xl items-start gap-3">
          <div className="min-w-0 flex-1">
            <p className="font-medium text-foreground">{banner.copy.title}</p>
            <p className="mt-0.5 text-xs text-text-light sm:text-sm">
              {banner.copy.body}
            </p>
            <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
              <button
                type="button"
                onClick={banner.openSheet}
                className="text-xs font-medium text-primary hover:underline sm:text-sm"
              >
                {banner.copy.primaryCta}
              </button>
              <button
                type="button"
                onClick={banner.dismiss}
                className="text-xs text-text-light hover:text-foreground sm:text-sm"
              >
                {banner.copy.secondaryCta}
              </button>
            </div>
          </div>
          <button
            type="button"
            onClick={banner.dismiss}
            className="shrink-0 rounded-md p-1 text-text-light hover:bg-surface/80 hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            aria-label="Dismiss notification setup reminder"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
      <NotificationSetupSheetMount />
    </>
  );
}
